<template>
  <div>
    <div class="myBtn" @click="clickBtn">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "n_button",
  components: {},
  props: {
    text: {
      type: String,
      default: ""
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    clickBtn() {
      this.$emit("clickFunc")
    }
  },
};
</script>

<style scoped lang="scss">
.myBtn {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  background: linear-gradient(327deg, #69d5ff 0%, #0084ff 100%);
  border-radius: 6px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  letter-spacing: 1px;
  padding: 0 15px;
  cursor: pointer;
  &:hover {
    opacity: 0.9;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/components/n_button.vue